import { useCoreAuth } from '@carvana/core-auth';
import { useEffect } from 'react';

import { startPageView } from '../../utilities/dataDog';
import ErrorPage from './ErrorPage';

const Unauthorized = () => {
  const { getUserState } = useCoreAuth();
  const { isLoggedIn } = getUserState();
  const subCopy = isLoggedIn ? '' : 'Please sign in to continue.';

  useEffect(() => {
    startPageView('Unauthorized Page');
  }, []);

  return <ErrorPage header="Uh oh! You cannot access this page." subheader={subCopy} />;
};

export default Unauthorized;
